import { render, staticRenderFns } from "./BcHome.vue?vue&type=template&id=82935350&scoped=true"
import script from "./BcHome.vue?vue&type=script&lang=js"
export * from "./BcHome.vue?vue&type=script&lang=js"
import style0 from "./BcHome.vue?vue&type=style&index=0&id=82935350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82935350",
  null
  
)

export default component.exports